import { createAsyncThunk } from "@reduxjs/toolkit";
import axios, { HttpStatusCode } from "axios";
import { notifyApiCallFailed } from "../notifications/notificationsSlice";

const api = axios.create({
  baseURL:
    process.env.REACT_APP_USE_LOCAL_API_URL === "true"
      ? process.env.REACT_APP_LOCAL_API_URL
      : process.env.REACT_APP_EXTERNAL_API_URL,
  responseType: "blob",
  headers: { Authorization: localStorage.getItem("token") || undefined },
});

export const fetchPreSignaturePdf = createAsyncThunk(
  "signature/fetchPreSignaturePdf",
  async ({ id }, { rejectWithValue, dispatch }) => {
    try {
      const { data, status } = await api.get(
        `/private_aviation/forms/${id}/serve_pre_signature_pdf` // Mock QA id: e2372682-bd77-4da4-908d-e5406b5b4ada
      );
      if (status !== HttpStatusCode.Ok) throw new Error("bad status");
      return URL.createObjectURL(data);
    } catch (err) {
      dispatch(notifyApiCallFailed());
      return rejectWithValue(err.message);
    }
  }
);

export const fetchSignedPdf = createAsyncThunk(
  "signature/fetchSignedPdf",
  async (
    { id, signature_type, signature_data },
    { rejectWithValue, dispatch }
  ) => {
    try {
      const { data, status } = await api.patch(
        `/private_aviation/forms/${id}/serve_unofficial_signed_pdf`,
        { signature_type, signature_data }
      );
      if (status !== HttpStatusCode.Ok) throw new Error("bad status");
      return URL.createObjectURL(data);
    } catch (err) {
      dispatch(notifyApiCallFailed());
      return rejectWithValue(err.message);
    }
  }
);
